<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="chapter-one"><div class="section level2" id="appetizers-all-the-young-dudes-cooking-the-foods">
<div class="section level3" id="baked-zeppelin-parmesan-zucchini-sticks">
<h3>Baked Zeppelin Parmesan Zucchini Sticks</h3>
<p style="text-indent:0px;">Trade your drumsticks in for these babies. This hearty and healthy appetizer is like a <strong><em>Stairway to Heaven</em></strong>.</p>
<br/>
<p style="font-weight:bold; text-align: center;"><a class="uri">https://www.youtube.com/watch?v=xbhCPt6PZIU</a></p>
<div class="figure" style="text-align: center;">
<img alt="" src="media/fil4.jpg" style="width:4.86034in;height:4.04167in"/>
<p class="caption">A plate of food Description automatically generated with medium confidence</p>
</div>
<br/>
<h4 style="text-indent:0px;"><strong>Ingredients</strong></h4>
<br/>
<p style="text-indent:0px;">3 medium zucchinis cut in sticks</p>
<p style="text-indent:0px;">1 cup homemade breadcrumbs (breadcrumbs made from egg and bread. It gives them a nice yellow colour)</p>
<p style="text-indent:0px;">1/2 cup Parmesan cheese grated</p>
<p style="text-indent:0px;">1 egg</p>
<p style="text-indent:0px;">1/4 tsp salt for taste</p>
<p style="text-indent:0px;">1/4 tsp pepper for taste</p>
<p style="text-indent:0px;">Ranch dressing optional</p>
<br/>
<p style="text-indent:0px;"><strong>Instructions</strong></p>
<br/>
<p style="text-indent:0px;"><strong>1. </strong>Preheat oven to 425 degrees F/220°C. Prepare a baking sheet with parchment paper.</p>
<p style="text-indent:0px;"><strong>2. </strong>I used 3 medium zucchini which I cut in half then each half in half lengthwise, and then each quarter in half again; so you end up with 8 sticks from one zucchini.</p>
<p style="text-indent:0px;"><strong>3. </strong>Beat the egg in a shallow plate. Season the egg with salt and pepper. In another shallow plate, mix the Panko breadcrumbs together with the Parmesan cheese. Season it with salt and pepper.</p>
<p style="text-indent:0px;"><strong>4. </strong>Dip each zucchini stick in the egg wash, and then roll through the breadcrumb mixture, making sure each stick is fully covered with the breadcrumbs.</p>
<p style="text-indent:0px;"><strong>5. </strong>Bake for about 20 minutes or until golden brown and crispy.</p>
<p style="text-indent:0px;"><strong>6. </strong>Serve it with Ranch dressing, blue cheese dressing or Marinara sauce.</p>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0005.vue?4e3d6072